var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PageTitle',[_vm._v("Opret ny global note")]),_c('section',{staticClass:"create-global"},[_c('Box',[_c('CreateGlobalNotes',{on:{"created":_vm.created}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }